import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const MenuManageCategories = ({
  idManageCategories,
  item,
  anchorSelected,
  anchorEl,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  setupdateData,
  triggerValue,
  setFormTrigger,
  itemState,
}) => {
  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorSelected === idManageCategories ? true : false)}
      keepMounted
      transition={"true"}
      onClose={() => {
        setAnchorEl(null);
        setAnchorSelected(null);
      }}
    >
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          setupdateData({ ...item });
          if (triggerValue !== "") setFormTrigger(triggerValue);
        }}
      >
        <EditIcon />
        &nbsp; Edit
      </MenuItem>
      {item.recordState.toLowerCase() !== "active" && (
        <MenuItem
          disabled={item.idCategory === 1 && item.idCategory ? true : false}
          onClick={() => {
            setAnchorEl(null);
            setAnchorSelected(null);
            setOpenDeleteModal(item);
          }}
        >
          <DeleteIcon />
          &nbsp; Delete
        </MenuItem>
      )}
    </Menu>
  );
};

export default MenuManageCategories;
